import {EntityIdentifierEnum, FeatureFlagEnum, ModuleEnum} from 'src/api/ProactApiClient';

export interface ModuleExtensionConfig {
  entityType: EntityIdentifierEnum;
  displayName: string;
  featureFlag?: FeatureFlagEnum; // omit = always available
}

export const ModuleExtensionRegistry: Partial<
  Record<ModuleEnum, ModuleExtensionConfig>
> = {
  [ModuleEnum.Personnel]: {
    entityType: EntityIdentifierEnum.User,
    displayName: 'Personnel',
  },
  [ModuleEnum.Assets]: {
    entityType: EntityIdentifierEnum.Asset,
    displayName: 'Assets',
    featureFlag: FeatureFlagEnum.Invalid,
  },
  [ModuleEnum.Actions]: {
    entityType: EntityIdentifierEnum.Action,
    displayName: 'Actions',
    featureFlag: FeatureFlagEnum.Actions,
  },
  [ModuleEnum.SafetyEvent]: {
    entityType: EntityIdentifierEnum.SafetyEvent,
    displayName: 'Safety Events',
    featureFlag: FeatureFlagEnum.SafetyEvents,
  },
  [ModuleEnum.Training]: {
    entityType: EntityIdentifierEnum.CourseDefinition,
    displayName: 'Training',
    featureFlag: FeatureFlagEnum.Training,
  },
  [ModuleEnum.ToolboxTalks]: {
    entityType: EntityIdentifierEnum.ToolboxTalk,
    displayName: 'Toolbox Talks',
  },
  [ModuleEnum.AssignedForms]: {
    entityType: EntityIdentifierEnum.AssignedForm,
    displayName: 'Assigned Forms',
  },
  [ModuleEnum.Forms]: {
    entityType: EntityIdentifierEnum.Form,
    displayName: 'Forms',
    featureFlag: FeatureFlagEnum.Forms,
  },
  [ModuleEnum.Documents]: {
    entityType: EntityIdentifierEnum.Document,
    displayName: 'Documents',
  },
  [ModuleEnum.UserGroups]: {
    entityType: EntityIdentifierEnum.UserGroup,
    displayName: 'User Groups',
  },
  [ModuleEnum.Vendors]: {
    entityType: EntityIdentifierEnum.Vendor,
    displayName: 'Vendors',
    featureFlag: FeatureFlagEnum.Vendors,
  },
  [ModuleEnum.ItemTrackerDefinitions]: {
    entityType: EntityIdentifierEnum.ItemDefinition,
    displayName: 'Item Tracker Definitions',
  },
  [ModuleEnum.ItemTrackerAssignments]: {
    entityType: EntityIdentifierEnum.ItemAssignment,
    displayName: 'Item Tracker Assignments',
  },
};

// slug convention MUST match ModuleCustomizationList nav: ModuleEnum[module].toLowerCase()
export const moduleExtensionSlug = (module: ModuleEnum): string =>
  ModuleEnum[module].toLowerCase();
